function initializeRasmExperience(scope) {
  scope.querySelectorAll('[data-style-finder]').forEach(function (finder) {
    if (finder.dataset.ready) return;
    finder.dataset.ready = 'true';
    var tabs = Array.from(finder.querySelectorAll('[data-style-tab]'));
    var panels = Array.from(finder.querySelectorAll('[data-style-panel]'));
    function select(tab, focus) {
      tabs.forEach(function (item) {
        item.setAttribute('aria-selected', String(item === tab));
        item.tabIndex = item === tab ? 0 : -1;
      });
      panels.forEach(function (panel) { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
      });
    });
  });
  scope.querySelectorAll('[data-rasm-pdp]').forEach(function (product) {
    var stage = product.querySelector('.rasm-pdp__stage');
    var main = product.querySelector('[data-rasm-main-image]');
    if (!stage || !main || stage.dataset.zoomReady) return;
    stage.dataset.zoomReady = 'true';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rs-image-zoom';
    button.textContent = '+';
    button.setAttribute('aria-label', 'View larger product image');
    button.title = 'View larger product image';
    var dialog = document.createElement('dialog');
    dialog.className = 'rs-image-dialog';
    dialog.setAttribute('aria-label', 'Product image close-up');
    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = 'Close';
    close.className = 'rs-image-dialog__close';
    var image = document.createElement('img');
    dialog.append(close, image);
    stage.append(button);
    product.append(dialog);
    button.addEventListener('click', function () {
      image.src = main.currentSrc || main.src;
      image.alt = main.alt;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    });
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      button.focus();
    });
  });
}
initializeRasmExperience(document);
document.addEventListener('shopify:section:load', function (event) { initializeRasmExperience(event.target); });

/* RASM_SCROLL_REVEAL_OCT11 */
(function(){function initReveal(){if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;if(!('IntersectionObserver' in window))return;var targets=document.querySelectorAll('.rasm-store .rs-section, .rasm-store .rs-editorial, .rasm-collection__hero, .rasm-collection__grid, .rasm-pdp__related, .rasm-search-page__grid, .rs-footer__newsletter');var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-revealed');observer.unobserve(entry.target);}})},{rootMargin:'0px 0px -25px 0px',threshold:0.05});targets.forEach(function(el){if(el.getBoundingClientRect().top<window.innerHeight*.9)return;el.classList.add('rs-reveal');observer.observe(el)});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initReveal,{once:true});else initReveal();})();
